import {useState, useEffect } from "react";
import { getdispensadorarea } from "../../services/public/dispensador";
import PropTypes from 'prop-types';
import Modal from "../modal";
import Toasts from "../toast";

function AreasDModal({ show, handleshow, handleparams, dispensaId, setarea }) {
const [areas, setAreas] = useState([]);
const [opciones, setOpciones] = useState([]);
const [showToast, setShowToast] = useState(false);

//------------------------------------------------------
const handleTurno = async (item) =>
  {
    setarea(item.AreaId);
    handleparams(item.AreaId)
    handleshow(false);
}   

//------------------------------------------------------
const CardServicios = ({data, onClick} ) => 
(
   <div className={`flex w-full h-[4.0rem] lg:h-[4.5rem] items-center bg-white text-dark rounded-lg shadow-lg shadow-default border border-stone-200 
                       hover:cursor-pointer hover:bg-body hover:scale-110 transition-transform duration-300`} 
                       onClick={()=>  onClick(data)}
   >
      <div className="flex w-full h-full items-center justify-center">
         <span className="w-full text-[0.85rem] lg:text-[1.5rem] text-center truncate">
             {data.NombreArea}
         </span>
      </div>
   </div>
);

//---------------------------------------------------------------------
const addAreas = async(dispensaId) =>
{
   const response = await getdispensadorarea(dispensaId);
             if (response)
              {
                if (response.status === 200) 
                  {
                    setAreas(response.data.data)
                  }
                else
                 {
                   const Mensaje = response.message;
                   const opc = { type: "Danger", message: Mensaje, active: true };
                   setOpciones(opc);
                   setShowToast(true);
                }
              }    
}

//------------------------------------------------------
useEffect(() => {
    if (show)
       addAreas(dispensaId);         
  }, [show]);

return (
    <>
       <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Seleccionar un área'}>
         <div className="h-[30rem] w-[40rem] flex flex-1 space-x-3 p-2 space-y-4 text-center items-center justify-center scroll-hidden">
            <div className="min-w-[70%] lg:min-w-[50%] mt-8 space-y-4" id="servicioview">
                {areas.map((item) => {
                  return (   
                    <div key={item.AreaId}>
                      <CardServicios data={item} onClick={handleTurno}></CardServicios>
                    </div>
                  );
                  
                })}
           </div>
         </div>
       </Modal> 
       {showToast && (
          <Toasts
            type={opciones.type}
            message={opciones.message}
            active={opciones.active}
          ></Toasts>
        )}
    </>
)
}
AreasDModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleshow: PropTypes.func.isRequired,
  handleparams: PropTypes.func.isRequired,
  dispensaId: PropTypes.number.isRequired,
  setarea: PropTypes.func.isRequired,
};

export default AreasDModal;